/* Umschaltung zwischen hellem und dunklem Design.
 *
 * Die Wahl wird im Browser des Nutzers gemerkt. Schlägt das fehl (privates
 * Fenster, blockierte Speicherung), gilt sie nur für diese Sitzung — das ist
 * kein Fehlerfall und wird bewusst still hingenommen.
 */

import { computed } from 'vue';
import { useTheme } from 'vuetify';
import { THEME_STORAGE_KEY } from '../plugins/vuetify.js';

export function useAppTheme() {
  const theme = useTheme();

  const isDark = computed(() => theme.global.name.value === 'dark');

  function set(name) {
    theme.change(name);
    try {
      localStorage.setItem(THEME_STORAGE_KEY, name);
    } catch {
      /* nicht kritisch */
    }
  }

  function toggle() {
    set(isDark.value ? 'light' : 'dark');
  }

  return { isDark, set, toggle, current: computed(() => theme.global.name.value) };
}
